export const DIRECTION_LEFT = 2;
export const DIRECTION_RIGHT = 4;
